import dayjs from 'dayjs'

const getTimeProperty = <T>(data: T, property: keyof T): string => {
  return String(data[property])
}

const inTimeBoundDate = <T>(
  seriesData: T[],
  duration: number,
  property: keyof T,
): T[] => {
  const beginDate = dayjs().startOf('day').subtract(duration, 'months')
  return seriesData.filter((data) => {
    const date = dayjs(getTimeProperty(data, property)).endOf('day')
    return date.isSame(beginDate) || date.isAfter(beginDate)
  })
}

export default inTimeBoundDate
